import { Dispatch, SetStateAction, useState } from 'react';
import { PriceConditionType } from '../../condition-types/price-condition/enums';

type PickerState<T> = {
  open: T;
  set: Dispatch<SetStateAction<T>>;
};

export type UsePickersReturnType = {
  timePicker: PickerState<boolean>;
  timeEndPicker: PickerState<boolean>;
  repeatPicker: PickerState<boolean>;
  weekDaysPicker: PickerState<boolean>;
  repeatCountPicker: PickerState<boolean>;
  fromHourPicker: PickerState<boolean>;
  toHourPicker: PickerState<boolean>;
  priceTypeConditionPicker: PickerState<PriceConditionType | true | null>;
  cheapestCountPicker: PickerState<boolean>;
  greaterPicker: PickerState<boolean>;
  lesserPicker: PickerState<boolean>;
  isEndDateOpen: PickerState<boolean>;
};

export const usePickers = () => {
  const [timePicker, setTimePicker] = useState<boolean>(false);
  const [timeEndPicker, setTimeEndPicker] = useState<boolean>(false);
  const [repeatPicker, setRepeatPicker] = useState<boolean>(false);
  const [weekDaysPicker, setWeekDaysPicker] = useState<boolean>(false);
  const [repeatCountPicker, setRepeatCountPicker] = useState<boolean>(false);
  const [fromHourPicker, setFromHourPicker] = useState<boolean>(false);
  const [toHourPicker, setToHourPicker] = useState<boolean>(false);
  const [priceTypeConditionPicker, setPriceTypeConditionPicker] = useState<PriceConditionType | true | null>(null);
  const [cheapestCountPicker, setCheapestCountPicker] = useState<boolean>(false);
  const [greaterPicker, setGreaterPicker] = useState<boolean>(false);
  const [lesserPicker, setLesserPicker] = useState<boolean>(false);
  const [isEndDateOpen, setIsEndDateOpen] = useState<boolean>(false);

  return {
    timePicker: {
      open: timePicker,
      set: setTimePicker,
    },
    timeEndPicker: {
      open: timeEndPicker,
      set: setTimeEndPicker,
    },
    repeatPicker: {
      open: repeatPicker,
      set: setRepeatPicker,
    },
    weekDaysPicker: {
      open: weekDaysPicker,
      set: setWeekDaysPicker,
    },
    repeatCountPicker: {
      open: repeatCountPicker,
      set: setRepeatCountPicker,
    },
    fromHourPicker: {
      open: fromHourPicker,
      set: setFromHourPicker,
    },
    toHourPicker: {
      open: toHourPicker,
      set: setToHourPicker,
    },
    priceTypeConditionPicker: {
      open: priceTypeConditionPicker,
      set: setPriceTypeConditionPicker,
    },
    cheapestCountPicker: {
      open: cheapestCountPicker,
      set: setCheapestCountPicker,
    },
    greaterPicker: {
      open: greaterPicker,
      set: setGreaterPicker,
    },
    lesserPicker: {
      open: lesserPicker,
      set: setLesserPicker,
    },
    isEndDateOpen: {
      open: isEndDateOpen,
      set: setIsEndDateOpen,
    },
  };
};
